import { connect } from "react-redux";
import AccountUrlResolver from "./AccountUrlResolver";
import { setAccountTab } from "./actions/route";
import { fetchAccount } from "./actions/accounts";

const mapStateToProps = (state, ownProps) => {
  const { accountId } = ownProps.match.params;

  return {
    tabIndex: state.route.accountTabIndex,
    labels: state.route.accountTabLabels,
    account: state.entities.accounts[accountId]
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    persistTab: index => {
      dispatch(setAccountTab(index));
    },

    fetchAccount: id => {
      dispatch(fetchAccount(id));
    }
  };
};

const AccountUrlResolverContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountUrlResolver);

export default AccountUrlResolverContainer;



// WEBPACK FOOTER //
// ./src/AccountUrlResolverContainer.js